import type { TrackReferenceOrPlaceholder } from "@livekit/components-react";
import { createContext, useContext } from "react";

/**
 * User-driven pin actions for the call layout. Routed through here (rather than
 * dispatching to LiveKit's pin state directly) so the conference can tell a manual
 * pin apart from its own auto-focus of a new screen share.
 */
export interface VideoCallPinControls {
  pinTrack: (trackRef: TrackReferenceOrPlaceholder) => void;
  unpin: () => void;
}

const VideoCallPinControlsContext = createContext<
  VideoCallPinControls | undefined
>(undefined);

export const VideoCallPinControlsProvider = VideoCallPinControlsContext.Provider;

export const useVideoCallPinControls = () =>
  useContext(VideoCallPinControlsContext);
